import * as React from 'react'

import {
  Box,
  Icon,
  NumberBadge,
  Text,
  Touchable,
  useToggle,
} from '@factorialco/deprecated-design-system'
import compact from 'lodash/compact'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import type { Competency } from 'modules/competencies/store/models/Competency'

interface Props {
  competency: Competency
}

const CompetencyInfo = ({ competency }: Props) => {
  const [open, toggle] = useToggle(false)

  const values = compact(
    competency.options.map((option) => {
      const { value, description } = option.attributes

      return (
        <Box key={option.attributes.id} flexDirection="row" gap="s8">
          <Box minWidth="s24">
            <NumberBadge label={value} />
          </Box>
          <Text.Normal weight="medium" color={description ? 'grey800' : 'grey600'}>
            {option.attributes.description ||
              i18n.t('competencies_v2.assessments.competency_info.empty_state')}
          </Text.Normal>
        </Box>
      )
    })
  )

  if (
    !competency.attributes.description &&
    !competency.options.some((x) => x.attributes.description)
  ) {
    return null
  }

  return (
    <>
      <Touchable onClick={toggle(true)}>
        <Icon.Medium icon="info-circle-line" color="grey800" />
      </Touchable>
      {open && (
        <Modal
          title={competency.attributes.name}
          illustration="window-user"
          onClose={toggle(false)}
        >
          <Box gap="s24" aria-label="competency-explanation">
            {competency.attributes.description && (
              <Text.Normal weight="medium">{competency.attributes.description}</Text.Normal>
            )}
            {values.length > 0 && (
              <Box flexDirection="column" gap="s16">
                <Text.Normal size="200">
                  {i18n.t('competencies_v2.assessments.competency_info.values')}
                </Text.Normal>
                <Box gap="s16">{values}</Box>
              </Box>
            )}
          </Box>
        </Modal>
      )}
    </>
  )
}

export default observer(CompetencyInfo)
